export default __webpack_public_path__ + "static/media/portfolio-nexx-1.c72825e8.jpg";